/**
 * Rendered when the authenticated Discord user is not a member of the
 * approved Runhuman guild OR has no Tester / Admin role assignment.
 */
export function NotAuthorizedView() {
  return (
    <div className="view view--not-authorized">
      <h1>Not authorized</h1>
      <p>
        Your Discord account isn't recognized as a Runhuman tester or admin in
        this server. If you believe this is wrong, ping a Volter team member
        in the server's <code>#help</code> channel.
      </p>
    </div>
  );
}
